module.exports = __webpack_public_path__ + "static/media/gunshot.4170cd60.mp3";